import React from 'react'
import PropTypes from 'prop-types'
import { useSnackbar } from 'notistack'
import Button from '@material-ui/core/Button'
import {
  useFindOrCreateChannelWithUserIds,
  useNavigateToChannel,
} from 'lib/stream-messaging/hooks'

const SendMessageButton = ({
  userIds,
  component = Button,
  isMaintenance,
  onClick,
  ...props
}) => {
  const findOrCreateChannelWithUserIds = useFindOrCreateChannelWithUserIds()
  const navigateToChannel = useNavigateToChannel()
  const { enqueueSnackbar } = useSnackbar()

  const handleSendMessage = async () => {
    onClick && onClick()
    const channel = await findOrCreateChannelWithUserIds(userIds)
    if (channel != null) {
      navigateToChannel(channel)
    } else {
      enqueueSnackbar(
        'Unable to create or join conversation. Please try again later.',
        { variant: 'error' },
      )
    }
  }

  const displayMaintenanceSnackbar = () => {
    onClick && onClick()
    enqueueSnackbar(
      'We are currently in the process of upgrading your messaging experience! Please check back again in just a bit. 👍',
      { variant: 'error' },
    )
  }

  return React.createElement(component, {
    onClick: !isMaintenance ? handleSendMessage : displayMaintenanceSnackbar,
    ...props,
  })
}

SendMessageButton.propTypes = {
  userIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  component: PropTypes.element,
  isMaintenance: PropTypes.bool,
  onClick: PropTypes.func,
}

const MaintenanceSendMessageButton = props => (
  <SendMessageButton isMaintenance {...props} />
)

export default SendMessageButton
export { MaintenanceSendMessageButton }
